const root = `td-register/statisty/`
const urls = {
  selectPunishIllegalPage: root + 'selectPunishIllegalPage',
  selectDaysPenaltyPage: root + 'selectDaysPenaltyPage',
  selectSealUpCasePage: root + 'selectSealUpCasePage',
  selectPolluteCrimeCasePage: root + 'selectPolluteCrimeCasePage',
  selectLimitStopCasePage: root + 'selectLimitStopCasePage',
  selectDetentiontCasePage: root + 'selectDetentiontCasePage',
  selectApplyEnforceCasePage: root + 'selectApplyEnforceCasePage',
  getGeneralPunishStatisty: root + 'getGeneralPunishStatisty',
  getSupportMeasureStatisty: root + 'getSupportMeasureStatisty',
  getClueSource: root + 'getClueSource',
  getIsYellowWarn: root + 'getIsYellowWarn',
  getSupportMeasureSum: root + 'getSupportMeasureSum',
  queryComprehensive: root + 'queryComprehensive',
  exportSupportMeasure: root + 'exportSupportMeasure',
  exportComprehensive: root + 'exportComprehensive',
  getIndustryClassCode: root + 'getIndustryClassCode',
  getCaseType: root + 'getCaseType',
  getIllegalAct: root + 'getIllegalAct',
  getCaseDataByDateType: root + 'getCaseDataByDateType',
  exportIndustryClassCode: root + 'exportIndustryClassCode',
  selectNoPunishPage: root + 'selectNoPunishPage',
  getCountByPunishType: root + 'getCountByPunishType',
  getCaseMaterialsNum: root + 'getCaseMaterialsNum',
  exportCaseMaterialsNum: root + 'exportCaseMaterialsNum',
  selectPenalizeByMoney: root + 'selectPenalizeByMoney',
  exportPenalizeByMoney: root + 'exportPenalizeByMoney',
  missDocumentNumber: 'td-register/missDocumentNumber/list',
  querymissDocumentNumberExport: 'td-register/missDocumentNumber/querymissDocumentNumberExport',
  missDocumentNumberUpdate: 'td-register/missDocumentNumber/update'
}

// 一般行政处罚查询分页
export const selectPunishIllegalPage = obj => {
  return $http.get(urls.selectPunishIllegalPage, obj)
}
// 按日连续处罚查询分页
export const selectDaysPenaltyPage = obj => {
  return $http.get(urls.selectDaysPenaltyPage, obj)
}
// 查封、扣押查询分页
export const selectSealUpCasePage = obj => {
  return $http.get(urls.selectSealUpCasePage, obj)
}
//涉嫌违法犯罪查询分页
export const selectPolluteCrimeCasePage = obj => {
  return $http.get(urls.selectPolluteCrimeCasePage, obj)
}
//限产、停产案件查询分页
export const selectLimitStopCasePage = obj => {
  return $http.get(urls.selectLimitStopCasePage, obj)
}
//适用行政拘留的违法情况案件查询分页
export const selectDetentiontCasePage = obj => {
  return $http.get(urls.selectDetentiontCasePage, obj)
}
//申请法院强制执行案件查询分页
export const selectApplyEnforceCasePage = obj => {
  return $http.get(urls.selectApplyEnforceCasePage, obj)
}
//查询一般行政处罚案件数和处罚金额
export const getGeneralPunishStatisty = obj => {
  return $http.get(urls.getGeneralPunishStatisty, obj)
}
//查询配套措施对应案件数和处罚金额
export const getSupportMeasureStatisty = obj => {
  return $http.get(urls.getSupportMeasureStatisty, obj)
}
//查询案源种类统计
export const getClueSource = obj => {
  return $http.get(urls.getClueSource, obj)
}
//查询办理状态
export const getIsYellowWarn = obj => {
  return $http.get(urls.getIsYellowWarn, obj)
}
//案件执行情况
export const getSupportMeasureSum = obj => {
  return $http.get(urls.getSupportMeasureSum, obj)
}
//导出案件执行情况
export const exportSupportMeasure = obj => {
  return $http.download(urls.exportSupportMeasure, obj)
}
//综合报表
export const queryComprehensive = obj => {
  return $http.get(urls.queryComprehensive, obj)
}
//导出综合报表
export const exportComprehensive = obj => {
  return $http.downloadByPost(urls.exportComprehensive, obj)
}

//行业分类查询
export const getIndustryClassCode = obj => {
  return $http.get(urls.getIndustryClassCode, obj)
}
//导出行业数据
export const exportIndustryClassCode = obj => {
  return $http.download(urls.exportIndustryClassCode, obj)
}
//违法案件类别统计查询接口
export const getCaseType = obj => {
  return $http.get(urls.getCaseType, obj)
}
//违法行为接口
export const getIllegalAct = obj => {
  return $http.get(urls.getIllegalAct, obj)
}
//获取案件趋势分析统计数据
export const getCaseDataByDateType = obj => {
  return $http.get(urls.getCaseDataByDateType, obj)
}
//获取案件趋势分析统计数据
export const selectNoPunishPage = obj => {
  return $http.get(urls.selectNoPunishPage, obj)
}
/**获取处罚种类统计 */
export const getCountByPunishType = obj => {
  return $http.get(urls.getCountByPunishType, obj)
}
/**案件数材料数统计 */
export const getCaseMaterialsNum = obj => {
  return $http.get(urls.getCaseMaterialsNum, obj)
}
//导出案件数材料数统计
export const exportCaseMaterialsNum = obj => {
  return $http.download(urls.exportCaseMaterialsNum, obj)
}
export const selectPenalizeByMoney = obj => {
  return $http.get(urls.selectPenalizeByMoney, obj)
}
export const exportPenalizeByMoney = obj => {
  return $http.download(urls.exportPenalizeByMoney, obj)
}
/** 缺失文书号查询 */
export const missDocumentNumber = obj => {
  return $http.get(urls.missDocumentNumber, obj)
}
/** 缺失文书号导出 */
export const querymissDocumentNumberExport = obj => {
  return $http.downloadByPost(urls.querymissDocumentNumberExport, obj)
}
/** 缺失文书号更新 */
export const missDocumentNumberUpdate = obj => {
  return $http.post(urls.missDocumentNumberUpdate, obj)
}
export default {
  selectPunishIllegalPage,
  selectDaysPenaltyPage,
  selectSealUpCasePage,
  selectPolluteCrimeCasePage,
  selectLimitStopCasePage,
  selectDetentiontCasePage,
  selectApplyEnforceCasePage,
  getGeneralPunishStatisty,
  getSupportMeasureStatisty,
  getClueSource,
  getIsYellowWarn,
  getSupportMeasureSum,
  queryComprehensive,
  exportComprehensive,
  getIndustryClassCode,
  getCaseType,
  getIllegalAct,
  getCaseDataByDateType,
  exportIndustryClassCode,
  selectNoPunishPage,
  getCountByPunishType,
  getCaseMaterialsNum,
  exportCaseMaterialsNum,
  selectPenalizeByMoney,
  exportPenalizeByMoney,
  missDocumentNumber,
  querymissDocumentNumberExport,
  missDocumentNumberUpdate,
  missDocumentNumberUpdate
}
